import React from 'react';
import { Box, Step, StepLabel, Stepper } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { StepIconRoot, StyledConnector } from './index.style';

const CircleCheckIcon = (props) => {
  const { active, completed, className } = props;
  return (
    <StepIconRoot ownerState={{ active, completed }} className={className}>
      <CheckIcon sx={{ fontSize: 24 }} />
    </StepIconRoot>
  );
};

const StatusStepper = ({ steps, activeStep, sx }) => {
  const { t } = useTranslation();

  const activeStepIndex = steps?.findIndex((item) =>
    item?.value?.includes(activeStep),
  );

  return (
    <Box sx={{ width: '100%', ...sx }}>
      <Stepper
        alternativeLabel
        activeStep={activeStepIndex}
        connector={<StyledConnector />}
      >
        {steps?.map((item, index) => (
          <Step
            key={item.label}
            completed={index < activeStepIndex}
            disabled={index > activeStepIndex}
          >
            <StepLabel
              StepIconComponent={CircleCheckIcon}
              sx={{
                '& .MuiStepLabel-label.MuiStepLabel-alternativeLabel': {
                  marginTop: '8px',
                },
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                <Typography
                  variant="body-14-medium"
                  color={
                    index > activeStepIndex ? COLOR.label2[48] : COLOR.darkGray
                  }
                >
                  {t(item.label)}
                </Typography>
              </Box>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default StatusStepper;
